const getTotal = (list, iteratee) => list.reduce((acc, item) => acc + iteratee(item), 0);
export const getTotalQuantityOfBricks = (list) => getTotal(list, (o) => o.quantity);
export const getTotalPreOrders = (list) => getTotal(list, o => o.totalPriceInclFees);
export const getAmountYouReceiveOnSale = (order) => order.totalPrice - (order.totalPriceInclFees - order.totalPrice);
export const getAmountYouPayOnPurchase = (order) => order.totalPriceInclFees;
export const getTotalSellOrders = (list) => getTotal(list, getAmountYouReceiveOnSale);
export const getTotalBuyOrders = (list) => getTotal(list, getAmountYouPayOnPurchase);
export const getPropertyFromOrder = (properties, order) => properties.find(({ propertyCode }) => order.propertyCode === propertyCode);
